import React from 'react';
import { getProjectState } from 'app/stores/project';
import { getPageByIdOrActive } from 'app/stores/selectors';
import { useConnect } from 'app/views/hooks/useConnect';
import { Marker } from './Marker';
export const Texts = (props) => {
    const { slideId } = props;
    const { texts, editedText } = useConnect(state => {
        var _a, _b;
        const projectState = getProjectState(state);
        return {
            texts: (_a = getPageByIdOrActive(state, slideId)) === null || _a === void 0 ? void 0 : _a.texts,
            editedText: state.editor.activeController === 'text-editor'
                ? (_b = projectState.selection) === null || _b === void 0 ? void 0 : _b[0]
                : undefined,
        };
    });
    return (React.createElement("g", null, texts &&
        texts.map(id => id !== editedText && React.createElement(Marker, { key: id, id: id }))));
};
